import Nav from './Nav'
export default Nav
